<div class="modal-md sap-modal" id="sap-modal">
  <div class="modal-header state">
    @if (headerLabel) {
      <h1 class="modal-title text-truncate full-width text-align-center">
        {{ headerLabel }}
      </h1>
    }
    @if (!headerLabel) {
      <h1
        class="modal-title text-truncate full-width text-align-center"
        id="modal-label"
      >
        {{ canSwitchOrderType ? 'SELECT ORDER TYPE' : 'MANAGE ORDER SETTINGS' }}
      </h1>
    }
    <button
      type="button"
      (click)="close()"
      class="btn btn-icon close"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    @if (canSwitchOrderType) {
      <div
        class="btn-group btn-group-toggle sap-modal--order-type"
        role="group"
        aria-label="Order Type"
      >
        <button
          type="button"
          id="btn-sap-order-type-standard"
          class="btn btn-secondary sap-order--type"
          [ngClass]="isSapType === SapType.STANDARD ? 'active' : ''"
          (click)="isSapType = SapType.STANDARD"
        >
          Standard Order
        </button>
        @if (canAddDecisionPointOrder) {
          <button
            id="btn-sap-order-type-decision-point"
            type="button"
            class="btn btn-secondary sap-order--type"
            [ngClass]="isSapType === SapType.DECISION_POINT ? 'active' : ''"
            (click)="isSapType = SapType.DECISION_POINT"
          >
            Decision Point Order
          </button>
        }
        <button
          id="btn-sap-order-type-wholesaler"
          type="button"
          class="btn btn-secondary sap-order--type"
          [ngClass]="isSapType === SapType.WHOLESALER ? 'active' : ''"
          (click)="isSapType = SapType.WHOLESALER"
        >
          Wholesaler Order
        </button>
      </div>
    }
    @if (isSapType === SapType.WHOLESALER) {
      <div class="sap-container--wholesaler">
        @if (canSwitchOrderType) {
          <h2>Select Wholesaler</h2>
          <div class="input-group">
            @if (canSwitchOrderType) {
              <ng-select
                class="custom-select__wholesalers"
                [items]="wholesalerSearchResults"
                [(ngModel)]="wholesalerSelectionId"
                bindValue="id"
                placeholder="Search Wholesaler"
                [searchable]="true"
                [loading]="wholesalerSearchLoading"
                [typeahead]="wholesalerSearchSubject"
                (change)="selectWholesaler($event)"
                [clearable]="false"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.label }}
                </ng-template>
                <ng-template ng-header-tmp> Search Wholesalers </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span>WSLR {{ item.external_id }} - {{ item.label }}</span>
                </ng-template>
              </ng-select>
            }
          </div>
        }
        <div class="input-group wholesaler--order-name">
          <label for="order-name">
            <span>Order Name</span>
            &nbsp;<small>(Name Your Order For Easy Reference)</small>
          </label>
          <input
            type="text"
            name="order-name"
            id="order-name"
            placeholder="Order name"
            [(ngModel)]="wslrOrderName"
          />
        </div>
        <div class="input-group">
          <label for="attention"
            ><span>Attention</span>&nbsp;<small
              >(Enter Attention Here)</small
            ></label
          >
          <input
            type="text"
            name="attention"
            id="wslr_attention"
            placeholder="{{
              order.isAttentionOverridden
                ? 'See Ship-To Address Details'
                : 'Enter Attention'
            }}"
            [(ngModel)]="attention"
          />
        </div>
        <div class="input-group wholesaler--tax-exempt">
          <label for="wslr-tax-exempt"
            >Tax Exempt:
            @if (!isWSLRTaxExemptAllowed) {
              <span
                class="color--primary-blue uppercase"
                placement="right"
                tooltipClass="tooltips"
                ngbTooltip="No certificates are on file, please contact each vendor with your certificates."
              >
                &nbsp;<i class="fas fa-info-circle"></i>
              </span>
            }
            <small
              >&nbsp;(Exemptions will be applied for suppliers holding proper
              exemption certificates)</small
            >
          </label>
          <input
            class="checkbox-dark-gray tax-exempt"
            type="checkbox"
            [(ngModel)]="wslrTaxExempt"
            id="wslr-tax-exempt"
          />
        </div>
        <button
          id="btn-start-wholesaler-order"
          [disabled]="!canCreateWSLROrder || inProgress"
          (click)="createWholesalerOrder()"
          type="button"
          class="btn btn-primary mt-3 mb-3"
        >
          {{ canSwitchOrderType ? 'Start Order' : 'Save' }}
          @if (inProgress) {
            &nbsp;<i class="fal fa-sync rotate"></i>
          }
        </button>
      </div>
    } @else {
      @if (isSapType === SapType.DECISION_POINT) {
        <div class="col-12 mt-0 mb-3 dp-search">
          @if (canSwitchOrderType) {
            <ng-select
              class="custom-select__decision-points"
              [items]="dpSearchResults"
              [(ngModel)]="dpSelectionId"
              bindValue="id"
              placeholder="Search Decision Points"
              [searchable]="true"
              [loading]="dpSearchLoading"
              [typeahead]="dpSearchSubject"
              (change)="selectDP($event)"
              [clearable]="false"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ dpSelection.label }}
              </ng-template>
              <ng-template ng-header-tmp> Search Results </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.label }}</span
                ><br />
                {{ item.wslr_count }} Wholesalers, {{ item.store_count }} Stores
              </ng-template>
            </ng-select>
          }
        </div>
      }
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="input-group pt-3">
              <app-payment-method-selector
                [useDefaultPayment]="true"
                [order]="order"
                [verifyingSAP]="verifyingSAP"
                [updatingPaymentMethod]="updatingPaymentMethod"
                [isModal]="true"
                (savedCard)="onSavedCard($event)"
                (paymentChanged)="onPaymentChanged($event)"
              ></app-payment-method-selector>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input-group">
              <label for="order-label">
                <span>Order Name</span>
                &nbsp;<small>(Name Your Order For Easy Reference)</small>
              </label>
              @if (isSapType === SapType.DECISION_POINT) {
                <input
                  type="text"
                  name="order-name"
                  id="order-label"
                  [(ngModel)]="dpOrderName"
                />
              }
              @if (isSapType === SapType.STANDARD) {
                <input
                  type="text"
                  name="order-name"
                  id="order-label"
                  [(ngModel)]="orderName"
                />
              }
            </div>
          </div>
          <div class="col-12">
            <div class="input-group">
              <label for="attention"
                ><span>Attention</span>&nbsp;<small
                  >(Enter Attention Here)</small
                ></label
              >
              <input
                type="text"
                name="attention"
                id="attention"
                placeholder="{{
                  order.isAttentionOverridden
                    ? 'See Ship-To Address Details'
                    : 'Enter Attention'
                }}"
                [(ngModel)]="attention"
                (click)="checkForAttentionChanges()"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="input-group">
              <label for="po_num">
                <span>PO #</span>
                &nbsp;<small>(Optional)</small>
              </label>
              <input
                type="text"
                name="po_num"
                id="po_num"
                [(ngModel)]="poNumber"
              />
            </div>
          </div>
          @if (isTaxExemptAllowed) {
            <div class="col-12">
              <div class="input-group">
                <label for="tax-exempt"
                  >Tax Exempt:
                  @if (!isTaxExemptAllowed) {
                    <span
                      class="color--primary-blue uppercase"
                      placement="right"
                      tooltipClass="tooltips"
                      ngbTooltip="No certificates are on file, please contact each vendor with your certificates."
                    >
                      &nbsp;<i class="fas fa-info-circle"></i>
                    </span>
                  }
                  <span class="lowercase"
                    >&nbsp;(Exemptions will be applied for suppliers holding
                    proper exemption certificates)</span
                  ></label
                >
                <div class="d-flex">
                  <input
                    class="checkbox-dark-gray tax-exempt"
                    type="checkbox"
                    [disabled]="!isTaxExemptAllowed"
                    [(ngModel)]="taxExempt"
                    id="tax-exempt"
                  />
                </div>
              </div>
            </div>
          }
        </div>
        <div class="row mb-3 mt-3">
          <button
            id="btn-apply-sap"
            (click)="onApplyPayment()"
            [disabled]="!canApply || inProgress"
            type="button"
            class="btn btn-primary apply-sap"
          >
            @if (inProgress) {
              <i class="fal fa-sync rotate"></i>
            }
            &nbsp; Apply &amp; Begin Order
          </button>
        </div>
      </div>
    }
  </div>
</div>
